angular.module('core')
    .filter('orderByTranslated', function ($translate, $filter) {
        return function (array, i18nKeyPrefix, objKey) {
            let result = [];
            let translated = [];
            angular.forEach(array, value => {
                let i18nKeySuffix = objKey ? value[objKey] : value;
                translated.push({
                    key: value,
                    label: $translate.instant(i18nKeyPrefix + i18nKeySuffix)
                });
            });
            angular.forEach($filter('orderBy')(translated, 'label'), sortedObject => {
                result.push(sortedObject.key);
            });
            return result;
        };
    })
